import { isGroupSetSchema, type SectionSchema, type GroupSchema } from '../types';
import type { Step } from '../models/Step';
import { useFormContext } from '../context/FormContext';
import { SectionGroupRenderer } from './GroupSet';

export function SectionView({
  sectionSchema,
  step,
}: {
  sectionSchema: SectionSchema;
  step: Step;
}) {
  const { displayService } = useFormContext();

  const section = step.sections.find((s) => s.id === sectionSchema.id);

  if (!section || !displayService.showSection(section)) {
    return null;
  }

  return (
    <div className="section">
      {sectionSchema.showTopDivider !== false && <hr className="pull-right" />}
      {section.label && <h3 className="no-line">{section.label}</h3>}

      {sectionSchema.supportText && (
        <div
          className="qa-support-text section-support-text"
          dangerouslySetInnerHTML={{ __html: sectionSchema.supportText }}
        />
      )}

      <div>
        {sectionSchema.groups?.map((groupOrSet) => (
          <SectionGroupRenderer
            key={isGroupSetKey(groupOrSet)}
            groupOrSet={groupOrSet}
            section={sectionSchema}
            sectionModel={section}
          />
        ))}
      </div>
    </div>
  );
}

function isGroupSetKey(groupOrSet: NonNullable<SectionSchema['groups']>[number]): string {
  if (isGroupSetSchema(groupOrSet)) {
    return groupOrSet.groupSetId;
  }
  return (groupOrSet as GroupSchema).id;
}
